var map = {
	"./1893/intro.jpg": "88bc",
	"./1925/intro.jpg": "e6eb",
	"./1949/intro.jpg": "5fa2",
	"./1951/intro.jpg": "6cc9",
	"./1956/intro.jpg": "0071",
	"./1960/intro.jpg": "2868",
	"./1982/intro.jpg": "a34a",
	"./1993/intro.jpg": "6030",
	"./2016/intro.jpg": "f30f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d76b";